// extracted by mini-css-extract-plugin
export default {"imgC":"Cv_imgC__N+FyR","img":"Cv_img__PM5rq","pulsate":"Cv_pulsate__NA5Eu","logo":"Cv_logo__Qvuxn","logoC":"Cv_logoC__iuAsY"};